export enum PROJECTS_STATUS {
    ACTIVO = 1,
    INACTIVO = 0,
    PAUSADO = 2,
    COMPLETADO = 3,
    DESESTIMADO = 4,
}

export enum STipoConfiguracion {
    Categorias = "CATEGORIAS",
    Proyectos = "PROYECTOS",
    ProyectosColaborador = "PROYECTOS_COLABORADOR",
    Requerimiento = "REQUERIMIENTO",
    TipoActividad = "TIPO_ACTIVIDAD",
    TipoHora = "TIPO_HORA",
};

export enum SEstadoHorario {
    Feriado = "FERIADO",
    FueraHorarioRegular = "FUERA_HORARIO_REGULAR",
    HorarioRegular = "HORARIO_REGULAR",
    PermisoDias = "PERMISO_DIAS",
    PermisoHoras = "PERMISO_HORAS",
};

export const taskMessage: string = "Podrás registrar horas adicionales 1 día hábil luego de la fecha de efecto";